<template>
  <div class="body-wrapper">
    <div class="body-wrapper table-poll">
      <div class="table-wrapper">
        <spinner
          class="spinner"
          line-fg-color="#00796b"
          :size="100"
          :line-size="6"
          v-if="loading"
        ></spinner>
        <div v-show="!loading">
          <button @click="addNewInfrastructure" class="btn">
            Dodaj infrastrukturu
          </button>
          <select
            class="form-control custom-select"
            id="selecCategory"
            @change="categoryChange"
            v-model="selectedCategory"
          >
            <option value="-1">Sve kategorije</option>
            <option
              v-for="cat in categories"
              :key="cat.value.id"
              :value="cat.value.id"
              >{{ cat.text }}</option
            >
          </select>
          <data-table
            :columns="table.tableColumns"
            :tableData="tableData"
            :options="table.tableOptions"
            :slotNameActionCommunityIntrastructures="'action'"
            @row-click="openInfrastructureDetails"
          ></data-table>
          <!-- :slotDatePost="'time'" -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/community/Table';
import { mapMutations, mapState, mapActions } from 'vuex';
import axios from '@/axios/axios.js';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      table: {
        tableColumns: [
          'name',
          'description',
          'infrastructure_type',
          'contractor',
          'action'
        ],
        tableOptions: {
          filterable: true,
          headings: {
            name: 'Naziv',
            description: 'Opis',
            infrastructure_type: 'Kategorija',
            contractor: 'Serviser',
            action: ''
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoji infrastruktura'
          },
          sortable: ['name']
        }
      },
      categories: [],
      allInfrastructure: [],
      selectedCategory: -1
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('modal', ['modalVisible']),
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  async created() {
    // alerts Community view that card is opened so
    // proper badge is loaded
    this.cardOpened();
    // set infra categories
    this.categories = await this.getInfrastructureCategories();

    //loading data to table
    this.allInfrastructure = await this.getAllInfrastructure({
      communityId: this.$store.getters.getActiveCommunity.community_id,
      infraTypes: this.$store.state.modal.infrastructureCategories
    });

    /*
     * setting badge of active view (polls)
     * */
    this.setTableBadge('fas fa-tools');
  },
  destroyed() {
    //unsetting badge when view is closed
    //this.unsetTableData();
    this.setTableBadge('');
  },
  methods: {
    ...mapMutations(['cardOpened', 'loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', [
      'showModal',
      'showModalWider',
      'setInfrastructureCategories'
    ]),
    ...mapMutations('table', [
      'setTableBadge',
      'unsetTableData',
      'setTableData'
    ]),

    ...mapActions('table', [
      'getAllInfrastructure',
      'getInfrastructureCategories'
    ]),
    categoryChange() {
      this.loadingStarted();
      if (this.allInfrastructure == null) {
        this.allInfrastructure = this.$store.getters['table/getTableData'];
      }
      console.log(this.selectedCategory);
      console.log(this.allInfrastructure);
      if (this.selectedCategory == -1) {
        this.setTableData(this.allInfrastructure);
      } else {
        this.setTableData(
          this.allInfrastructure.filter(
            infra => infra.infrastructure_type_id == this.selectedCategory
          )
        );
      }
      this.loadingFinished();
    },
    addNewInfrastructure() {
      this.selectedCategory = -1;
      this.categoryChange();
      this.allInfrastructure = null;
      this.showModal('ModalAddNewCommunityInfrastructure');
    },
    openInfrastructureDetails(data) {
      this.$router.push({
        name: 'communityInfrastructureDetails',
        params: {
          infrastructureId: data.row.id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.body-wrapper {
  display: block;
  padding: 10px;

  .badge--mod {
    position: absolute;
    right: 0;
    left: unset;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
  }
}

#selecCategory {
  position: absolute;
  right: 230px;
  z-index: 10;
  width: 180px;
  text-align: center;
  font-size: 1rem;
}

.table-wrapper {
  position: relative;
}

.VuePagination {
  display: none;
}

h1,
h2 {
  text-align: center;
}

h1 {
  padding-top: 25px;
  position: relative;
}

h2 {
  color: #636363;
  padding-bottom: 20px;
}

i {
  padding: 5px;
  position: absolute;
  left: 0;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.25s;
}

i:hover {
  background-color: rgba(176, 178, 178, 0.5);
}

.spinner {
  padding-top: 10%;
}

.btn {
  background: var(--primary-color);
  color: white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.btn:focus {
  box-shadow: none;
}
</style>
